export const WEB_DASHBOARD_LAYOUT_MODES = Object.freeze({
  PIXELS: 'pixels',
  PERCENTAGE: 'percentage',
});

export const normalizeWebDashboardLayoutMode = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized === WEB_DASHBOARD_LAYOUT_MODES.PERCENTAGE
    ? WEB_DASHBOARD_LAYOUT_MODES.PERCENTAGE
    : WEB_DASHBOARD_LAYOUT_MODES.PIXELS;
};

export const isPercentageWebDashboardTab = (tab) =>
  normalizeWebDashboardLayoutMode(tab?.layoutMode) === WEB_DASHBOARD_LAYOUT_MODES.PERCENTAGE;

export const normalizeWebDashboardTab = (tab) => {
  if (!tab || typeof tab !== 'object') {
    return tab;
  }

  const accessRole = Array.isArray(tab.access_role)
    ? tab.access_role
    : (tab.access_role ? [tab.access_role] : (Array.isArray(tab.access_roles) ? tab.access_roles : ['super', 'owner']));

  return {
    ...tab,
    access_role: accessRole,
    widgets: Array.isArray(tab.widgets) ? tab.widgets.filter(Boolean) : [],
    layoutMode: normalizeWebDashboardLayoutMode(tab.layoutMode),
  };
};

export const normalizeWebDashboardTabs = (tabs) =>
  Array.isArray(tabs) ? tabs.filter(Boolean).map(normalizeWebDashboardTab) : [];

export const createDefaultWebDashboardTab = ({
  id,
  name = 'Dashboard',
  accessRole = ['super', 'owner'],
  layoutMode = WEB_DASHBOARD_LAYOUT_MODES.PIXELS,
  fixedWidth = false,
} = {}) => {
  const normalizedLayoutMode = normalizeWebDashboardLayoutMode(layoutMode);

  return {
    ...(id ? { id } : {}),
    name,
    access_role: Array.isArray(accessRole) && accessRole.length > 0 ? accessRole : ['super', 'owner'],
    widgets: [],
    layoutMode: normalizedLayoutMode,
    fixedWidth: Boolean(fixedWidth),
  };
};

export const getWebDashboardLayoutOptions = (translations = {}) => [
  {
    value: WEB_DASHBOARD_LAYOUT_MODES.PIXELS,
    label: translations?.layoutModes?.pixels?.label || 'Fixed Pixels',
    description:
      translations?.layoutModes?.pixels?.description ||
      'Current behavior with px-based widget coordinates and sizes.',
  },
  {
    value: WEB_DASHBOARD_LAYOUT_MODES.PERCENTAGE,
    label: translations?.layoutModes?.percentage?.label || 'Percentage',
    description:
      translations?.layoutModes?.percentage?.description ||
      'Responsive layout that scales widgets with the dashboard size.',
  },
];

export const getWebDashboardLayoutLabel = (layoutMode, translations = {}) => {
  const normalizedLayoutMode = normalizeWebDashboardLayoutMode(layoutMode);
  const option = getWebDashboardLayoutOptions(translations).find(
    ({ value }) => value === normalizedLayoutMode,
  );

  return option?.label || 'Fixed Pixels';
};

export const getEffectiveFixedWidthValue = (tab) =>
  (typeof tab?.fixedWidth === 'boolean' ? tab.fixedWidth : true);
